import download from "downloadjs";

export const handleDownloadTemplateFile = (): void => {
  const filename = "suppliers.csv";

  const data = `Name;Email;VAT;Registered;Submitted;Deadline;NACESection;NACEDivision;AnnualProcurementValue\n\n`;

  download(data, filename);
};
